import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import StatsBand from "@/components/site/StatsBand";
import MallSuite from "@/components/site/MallSuite";
import SmartCaddy from "@/components/site/SmartCaddy";
import ComparisonTable from "@/components/site/ComparisonTable";
import About from "@/components/site/About";
import Deployment from "@/components/site/Deployment";
import Compliance from "@/components/site/Compliance";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";

function HomePage() {
    return (
        <div className="App font-body bg-rt-bg text-white" data-testid="retechler-home">
            <Navbar />
            <main>
                <Hero />
                <StatsBand />
                <MallSuite />
                <SmartCaddy />
                <ComparisonTable />
                <About />
                <Deployment />
                <Compliance />
                <ContactForm />
            </main>
            <Footer />
            <Toaster position="bottom-right" theme="dark" />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="*" element={<HomePage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
